<template>
    <div class="flex">
        <Head>
            <title>Messages</title>
        </Head>

        <!--Messages-->
        <section v-show="!isConversationsList" class="relative flex flex-1 flex-col justify-between ml-0 min-w-0 min-h-screen bg-white border-r border-gray-200 md:ml-80 xl:order-last xl:ml-96">
            <div class="sticky z-30 top-14 flex-shrink-0 bg-white border-b border-gray-200 md:top-0">
                <!-- Toolbar-->
                <div class="h-18 flex flex-col justify-center md:h-16">
                    <div class="px-4 sm:px-6 lg:px-8">
                        <div class="flex justify-between py-3">
                            <div v-if="participant && route().current('messenger.conversation', { user: participant.username })" class="flex items-center space-x-3">
                                <avatar :user="participant" class="w-11 h-11"></avatar>
                                <h1 class="text-xl font-medium">{{ participant.tag }}</h1>
                            </div>
                        </div>
                    </div>
                    <div class="flex items-center px-4 py-2 bg-gray-100 border-t border-gray-200 md:hidden">
                        <Link :href="route('messenger.conversations')" class="flex items-center text-gray-600 text-xs font-light uppercase">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                            </svg>
                            <span>{{ conversations.length | abbr }} {{ "conversation" | pluralize(conversations.length) }}</span>
                        </Link>
                    </div>
                </div>
            </div>

            <!--Messages Panel-->
            <messages-panel v-if="messages" :messages.sync="messages" :participant="participant" />

            <!--Message Form-->
            <messenger-form v-if="participant" :messages.sync="messages" :is-bot="isBot" />
        </section>

        <!--Conversations-->
        <div :class="[isConversationsList ? 'w-full' : 'hidden md:inline-block w-80 xl:w-96']" class="fixed z-30 top-14 h-full border-l border-r border-gray-200 md:top-0">
            <div>
                <div v-show="!isConversationsList" class="flex flex-col justify-center px-4 h-16 bg-white">
                    <div class="flex items-baseline space-x-3">
                        <h2 class="text-gray-900 text-lg font-medium">Messages</h2>
                    </div>
                </div>
                <div class="flex items-center px-4 h-8 bg-gray-100 border-b border-t border-gray-200">
                    <p class="text-gray-600 text-xs font-light uppercase">{{ conversations.length | abbr }} {{ "conversation" | pluralize(conversations.length) }}</p>
                </div>
            </div>
            <conversations :class="{ 'hidden md:block': !isConversationsList }" :conversations="conversations" :participant="participant" />
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Heading from "@/Components/Heading"
import Tooltip from "@/Components/Tooltip"
import JetInputError from "@/Jetstream/InputError"
import JetActionMessage from "@/Jetstream/ActionMessage"
import JetSecondaryButton from "@/Jetstream/SecondaryButton"
import JetDangerButton from "@/Jetstream/DangerButton"
import JetButton from "@/Jetstream/Button"
import AlertWarning from "@/Components/Alerts/Warning"
import Conversations from "@/Pages/Messenger/Conversations"
import MessagesPanel from "@/Pages/Messenger/MessagesPanel"
import MessengerForm from "@/Pages/Messenger/MessengerForm"

export default {
    name: "Messenger",

    layout: AppLayout,

    components: {
        MessengerForm,
        MessagesPanel,
        Conversations,
        Tooltip,
        Heading,
        JetDangerButton,
        JetSecondaryButton,
        JetButton,
        JetActionMessage,
        JetInputError,
        AlertWarning,
    },

    mounted() {
        // <meta name="viewport" content="initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, width=device-width, height=device-height, target-densitydpi=device-dpi">
        // this.meta = document.createElement("meta")
        // this.meta.setAttribute("name", "viewport")
        // this.meta.setAttribute("content", "initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, width=device-width, height=device-height, target-densitydpi=device-dpi")
        // document.head.appendChild(this.meta)
    },

    props: {
        conversations: {
            required: true,
            type: Array,
        },
        conversation: {
            default: null,
            type: Object,
        },
        participant: {
            type: Object,
        },
    },

    computed: {
        messages: {
            get() {
                if (!this.conversation) return null
                return this.conversation.messages
            },
            set() {
                //
            },
        },

        isConversationsList() {
            return this.$page.url === "/messages/conversations"
        },

        isBot() {
            return this.participant.username === "challenge-bot"
        },
    },

    data() {
        return {
            meta: null,
        }
    },

    beforeDestroy() {
        // document.head.removeChild(this.meta)
    },
}
</script>
